export function getPluralForm(
  number: number,
  locale: string = 'en',
): Intl.LDMLPluralRule {
  const pluralRules = new Intl.PluralRules(locale);
  return pluralRules.select(number);
}
